// slices/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    name: '',
    loggedIn: false,
    token: '',
    accessToken: '',
    refreshToken: '',
    expiresIn: { 
        loggedInTime: '', 
        expiryTime: '', 
        expiryInterval: '' 
    },
    userCredentials: {},
    version: '',
    roleWisePermission: {},
    userType: '',
    session: "",
    userDetails: {},
    isCollapsed: false,
    loginType: '',
    isRequiredParameterMissing: false,
    switchUserId: {},
    childName: "",
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setLoginData(state, action) {
            const { token, userDetails } = action.payload;

            state.loggedIn = true;
            state.token = token || "";
            state.accessToken = token || "";
            state.userDetails = userDetails || {};

            // Derived fields
            state.name = userDetails?.fullName || "";
            state.userType = userDetails?.role || "";
        },

        setSwitchUserId(state, action) {
            state.switchUserId = action.payload || {};
        },

        setUserDetails(state, action) {
            state.userDetails = action.payload || {};
        },

        setChildName(state, action) {
            state.childName = action.payload || "";
        },

        setUserType(state, action) {
            state.userType = action.payload || "";
        },

        logout(state) {
            // Reset everything by replacing with initialState
            return initialState;
        },
    },
});

export const { 
    setLoginData, 
    logout, 
    setSwitchUserId, 
    setUserDetails, 
    setChildName, 
    setUserType 
} = userSlice.actions;

export default userSlice.reducer;
